/* eslint-disable no-unused-vars */
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Divider, Grid, Typography } from '@mui/material';
import React from 'react';
import PackageDetailsCollapsibleList from './PackageDetailsCollapsibleList';
import PackageDetailsLocationMap from './PackageDetailsLocationMap';
import PackageDetailsOverviewItem from './PackageDetailsOverviewItem';

export default function PackageDetailsBasicInformationTab({
  id,
  overviewItems,
  collapsibleItems,
}) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          <LocalShippingIcon sx={{ mr: 1 }} />
          Basic Information
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>

      {overviewItems.map(({ title, value }) => (
        <PackageDetailsOverviewItem key={title} title={title} value={value} />
      ))}

      {collapsibleItems.map(({ label, items: listItems }) =>
        label === 'Scanned At Coordinates' ? (
          <PackageDetailsLocationMap
            key={label}
            label={label}
            lat={listItems[0]}
            lng={listItems[1]}
          />
        ) : (
          <PackageDetailsCollapsibleList
            key={label}
            label={label}
            items={listItems}
          />
        )
      )}
    </Grid>
  );
}
